import { render, staticRenderFns } from "./edit-somkeleaf.vue?vue&type=template&id=7d8ee4ca&"
import script from "./edit-somkeleaf.vue?vue&type=script&lang=ts&"
export * from "./edit-somkeleaf.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports